export default { sha: 'e08cd0ba830279cab90f91708ce45069fd1953d2', buildNumber: 'undefined' }
